/**
 * @fileoverview Limit System Default Values - 制限システムのデフォルト値
 *
 * ゲーム全体で共有される制限値の定数。
 * core層（GameState初期化）とgameplay層（ドライバ）の両方から参照される。
 */

/**
 * デフォルト制限値
 */
export const DEFAULT_LIMIT_VALUES = Object.freeze({
  /** 時間制限（ミリ秒） */
  TIME_LIMIT_MS: 30_000, // 30 seconds

  /** 手数制限 */
  MAX_MOVES: 20, // 20 moves
});

/**
 * イントロアニメーション設定
 */
export const INTRO_ANIMATION = Object.freeze({
  /** イントロアニメーション期間（ミリ秒） */
  DURATION_MS: 650,
});
